import MuiAvatar from '@mui/material/Avatar';
import MuiBadge from '@mui/material/Badge';
import MuiChip from '@mui/material/Chip';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import MuiListItemText from '@mui/material/ListItemText';
import MuiTable from '@mui/material/Table';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableHead from '@mui/material/TableHead';
import MuiTablePagination from '@mui/material/TablePagination';
import MuiTableRow from '@mui/material/TableRow';
import MuiTooltip from '@mui/material/Tooltip';
import { wrap } from '../wrap';

export const Chip = wrap(MuiChip, 'Chip', { size: true, tone: true, emphasis: 'chip' });
export const Avatar = wrap(MuiAvatar, 'Avatar');
export const Badge = wrap(MuiBadge, 'Badge', { tone: true });
export const Tooltip = wrap(MuiTooltip, 'Tooltip');

export const List = wrap(MuiList, 'List');
export const ListItem = wrap(MuiListItem, 'ListItem');
export const ListItemButton = wrap(MuiListItemButton, 'ListItemButton');
export const ListItemIcon = wrap(MuiListItemIcon, 'ListItemIcon');
export const ListItemText = wrap(MuiListItemText, 'ListItemText', {
  slots: { primaryTypographyProps: 'primary', secondaryTypographyProps: 'secondary' },
});
export const ListItemSecondaryAction = wrap(MuiListItemSecondaryAction, 'ListItemSecondaryAction');

export const Table = wrap(MuiTable, 'Table', { size: true });
export const TableBody = wrap(MuiTableBody, 'TableBody');
export const TableCell = wrap(MuiTableCell, 'TableCell', { size: true });
export const TableHead = wrap(MuiTableHead, 'TableHead');
export const TablePagination = wrap(MuiTablePagination, 'TablePagination');
export const TableRow = wrap(MuiTableRow, 'TableRow');

export { Image } from './Image';
export type { ImageProps } from './Image';

export { TableContainer } from './TableContainer';
export type { TableContainerProps } from './TableContainer';

export { Text } from './Text';
export type { TextLevel, TextProps } from './Text';
